<template>
  <div class="d-flex align-center">
    <v-progress-circular
      class="progress"
      :value="value"
      :size="60"
      :width="2"
      :color="progressColor(value)"
      :rotate="270"
    >
      <span class="progress-value">{{ `${value}%` }}</span>
    </v-progress-circular>
    <div class="d-flex align-center">
      <span class="ml-5 text-uppercase">{{ name }}</span>
      <v-tooltip
        v-if="tooltip.name && tooltip.description"
        bottom
        :max-width="tooltipMaxWidth"
      >
        <template v-slot:activator="{ on }">
          <v-icon small color="primary" v-on="on" class="ml-1">
            mdi-information-outline
          </v-icon>
        </template>
        <span>{{ tooltip.description }}</span>
      </v-tooltip>
    </div>
  </div>
</template>

<script>
export default {
  name: "ExpansionPanelHeaderProgress",
  props: {
    value: {
      type: Number,
      required: true
    },
    name: {
      type: String,
      default: ""
    },
    tooltip: {
      type: Object,
      default: () => {
        return { name: "", description: "" };
      }
    }
  },

  data() {
    return {
      tooltipMaxWidth: 500
    };
  },

  methods: {
    progressColor(val) {
      if (val >= 0 && val <= 49) return "error";
      if (val >= 50 && val <= 89) return "warning";
      if (val >= 90 && val <= 100) return "success";
    }
  }
};
</script>

<style lang="scss">
.progress {
  min-width: 58px;
}

.progress .v-progress-circular__underlay {
  stroke: $light;
}

.progress-value {
  font-weight: $font-weight-bold;
}
</style>
